import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import { useFetchSelectorTopics } from 'actions/topics';
import { checkIsBadge } from 'types/badges';
import { TYPE_PLAYLIST_THUMBNAIL } from 'utils/file';
import Hint from 'components/Hint';
import FormField, { DefaultFormFieldLayout } from 'components/FormField';
import { ImageField, TagField, LanguageField, TopicField, BadgeField, formatTags } from 'components/FormFields';
import FormStack from 'components/FormStack';
import TextArea from 'components/TextArea';
import TextInput from 'components/TextInput';
import { ContentDetailsInfo, ParentPlaylistsInfo } from 'components/ContentInfo';
import TitleCard from 'components/TitleCard';
export function GeneralDetailsCard(_ref) {
  var _fields$badge$value, _playlist$parentPlayl;
  var playlist = _ref.playlist,
    playlistForm = _ref.playlistForm,
    _ref$withParentPlayli = _ref.withParentPlaylistsInfo,
    withParentPlaylistsInfo = _ref$withParentPlayli === void 0 ? false : _ref$withParentPlayli,
    isDistributed = _ref.isDistributed,
    isDeleted = _ref.isDeleted;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isDeletedOrDistributed = isDistributed || isDeleted;
  var fields = playlistForm.fields;
  var _useFetchSelectorTopi = useFetchSelectorTopics(),
    fetchedTopics = _useFetchSelectorTopi.items;
  var emptyNameAlert = fields.name.wasChanged ? fields.name.error : undefined;
  var badge =
  // Was the badge deleted?
  ((_fields$badge$value = fields.badge.value) === null || _fields$badge$value === void 0 ? void 0 : _fields$badge$value.imageId) === null ?
  // Empty badge in case of deletion
  undefined :
  // Otherwise, the badge is the current badge
  fields.badge.value;
  var hasParentPlaylists = !!(playlist !== null && playlist !== void 0 && (_playlist$parentPlayl = playlist.parentPlaylists) !== null && _playlist$parentPlayl !== void 0 && _playlist$parentPlayl.length);
  var showParentPlaylistsInfo = withParentPlaylistsInfo && hasParentPlaylists;
  return /*#__PURE__*/React.createElement(TitleCard, {
    title: t('menu_general_settings'),
    sideContent: playlist && /*#__PURE__*/React.createElement(ContentDetailsInfo, {
      content: playlist,
      type: "playlist"
    })
  }, /*#__PURE__*/React.createElement(DefaultFormFieldLayout, {
    horizontal: true
  }, /*#__PURE__*/React.createElement(FormStack, {
    spacing: "m"
  }, (showParentPlaylistsInfo || isDistributed) && /*#__PURE__*/React.createElement(React.Fragment, null, showParentPlaylistsInfo && playlist.parentPlaylists && /*#__PURE__*/React.createElement(ParentPlaylistsInfo, {
    parentPlaylists: playlist.parentPlaylists,
    type: "playlist"
  }), isDistributed && /*#__PURE__*/React.createElement(Hint, {
    icon: "share"
  }, t('immutability_note_distributed_item_fields'))), /*#__PURE__*/React.createElement(FormField, {
    required: true,
    label: "".concat(t('form_title'), " *"),
    alert: emptyNameAlert
  }, /*#__PURE__*/React.createElement(TextInput, {
    value: fields.name.value,
    onChange: function onChange(e) {
      return fields.name.set(e.target.value);
    },
    disabled: isDeletedOrDistributed
  })), /*#__PURE__*/React.createElement(ImageField, {
    id: "playlistCoverImage",
    thumbnailId: fields.thumbnailId.value,
    onChange: function onChange(e) {
      return fields.thumbnailId.set(e);
    },
    isDisabled: isDeletedOrDistributed,
    contentType: TYPE_PLAYLIST_THUMBNAIL,
    contentId: playlist === null || playlist === void 0 ? void 0 : playlist.id,
    contentName: fields.name.value,
    contentDescription: fields.description.value,
    badge: checkIsBadge(badge) ? badge : undefined
  }), /*#__PURE__*/React.createElement(FormField, {
    label: t('form_description')
  }, /*#__PURE__*/React.createElement(TextArea, {
    maxRows: 8,
    minRows: 3,
    value: fields.description.value,
    onChange: function onChange(e) {
      return fields.description.set(e.target.value);
    },
    disabled: isDeletedOrDistributed
  })), /*#__PURE__*/React.createElement(TagField, {
    selectedTags: formatTags(fields.tags.value),
    onChangeSelectedTags: function onChangeSelectedTags(data) {
      return fields.tags.set(data.selectedItems.map(function (_ref2) {
        var id = _ref2.id,
          name = _ref2.name;
        return {
          id: id,
          name: name
        };
      }));
    },
    isDisabled: isDeletedOrDistributed
  }), (fetchedTopics === null || fetchedTopics === void 0 ? void 0 : fetchedTopics.length) >= 1 && /*#__PURE__*/React.createElement(TopicField, {
    isDisabled: isDeleted,
    selectedTopics: fields.topics.value,
    onChange: function onChange(_ref3) {
      var selectedItems = _ref3.selectedItems;
      return fields.topics.set(selectedItems);
    }
  }), config.assetLanguageEnabled && /*#__PURE__*/React.createElement(LanguageField, {
    value: fields.locale.value,
    onChange: function onChange(newPlaylistLocale) {
      return fields.locale.set(newPlaylistLocale);
    },
    isDisabled: isDeletedOrDistributed
  }), config.badges && /*#__PURE__*/React.createElement(BadgeField, {
    badge: badge,
    onChange: function onChange(badge) {
      return fields.badge.set(badge);
    },
    parentPlaylistId: playlist === null || playlist === void 0 ? void 0 : playlist.id,
    isDisabled: isDeleted
  }))));
}
export default GeneralDetailsCard;